"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluate = void 0;
var node_fetch_1 = __importDefault(require("node-fetch"));
var evaluate = function (nodeApi, dapp, func, _fetch) {
    if (_fetch === void 0) { _fetch = node_fetch_1.default; }
    return _fetch("".concat(nodeApi, "/utils/script/evaluate/").concat(dapp), {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: "{\"expr\":\"".concat(func.split("\"").join("\\\""), "\"}")
    })
        .then(function (x) { return x.json(); })
        .then(function (x) { return x.error ? Promise.reject(x) : x.result.value; });
};
exports.evaluate = evaluate;
//# sourceMappingURL=evaluate.js.map